const menuItems = [
  {
    categoria: 'Cafés',
    icono: 'ri-cup-line',
    items: [
      { nombre: 'Café Americano', descripcion: 'Espresso con agua caliente, intenso y aromático' },
      { nombre: 'Café Latte', descripcion: 'Espresso suave con leche vaporizada cremosa' },
      { nombre: 'Capuchino', descripcion: 'Espresso con espuma de leche y un toque de cacao' },
    ],
  },
  {
    categoria: 'Pastelería & Snack',
    icono: 'ri-cake-2-line',
    items: [
      { nombre: 'Facturas dulces y saladas', descripcion: 'Variedad artesanal recién horneada cada mañana' },
      { nombre: 'Selladito jamón queso', descripcion: 'Crujiente por fuera, fundido por dentro' },
    ],
  },
];

export default function CartaCafeteriaSection() {
  return (
    <section id="carta" className="py-24 bg-stone-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Encabezado */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-1.5 rounded-full text-sm font-semibold mb-5">
            <i className="ri-restaurant-line text-base"></i>
            <span>Nuestra Carta</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-stone-800 mb-4 font-serif">
            Carta de la Cafetería
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed">
            Café y delicias para disfrutar en un ambiente boutique patagónico.
          </p>
        </div>

        {/* Categorías */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
          {menuItems.map((cat) => (
            <div
              key={cat.categoria}
              className="bg-white rounded-2xl border border-stone-200 overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300"
            >
              {/* Header de categoría */}
              <div className="bg-stone-800 px-6 py-4 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${cat.icono} text-amber-400 text-xl`}></i>
                </div>
                <h3 className="text-white font-bold text-lg tracking-wide">{cat.categoria}</h3>
              </div>

              {/* Items */}
              <div className="divide-y divide-stone-100">
                {cat.items.map((item, idx) => (
                  <div
                    key={idx}
                    className="px-6 py-5 flex items-start gap-4 hover:bg-amber-50/40 transition-colors"
                  >
                    <div className="w-2 h-2 rounded-full bg-amber-500 mt-2.5 shrink-0"></div>
                    <div>
                      <h4 className="font-semibold text-stone-800 text-base">{item.nombre}</h4>
                      <p className="text-sm text-stone-500 mt-1 leading-relaxed">{item.descripcion}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Botón WhatsApp */}
        <div className="text-center">
          <a
            href="https://wa.me/56994347092"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full font-semibold text-base transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap hover:-translate-y-0.5"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Pedir por WhatsApp
          </a>
          <p className="text-sm text-stone-500 mt-4">
            Consulta disponibilidad y realiza tu pedido directamente
          </p>
        </div>
      </div>
    </section>
  );
}